import { Tooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { TooltipText } from '../TooltipText';

import * as style from './style.css';

interface IPriceRelevanceWarningProps {
  title: string;
  description: string;
  label: string;
}

export const PriceRelevanceActual = ({ title, description, label }: IPriceRelevanceWarningProps) => {
  return (
    <div className={style['container']}>
      <span className={style['label']}>
        <UIText2 color="gray60_100">{label}</UIText2>
      </span>
      <span className={style['icon']}>
        <Tooltip theme="white" header={title} placement="right" title={<TooltipText text={description} />}>
          <IconFunctionalInformationCircle16 color="icon-main-default" />
        </Tooltip>
      </span>
    </div>
  );
};
